import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RegistrationHeader = () => {
  return (
    <header className="bg-card border-b border-border shadow-elevation-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/homepage" className="flex items-center space-x-2 transition-micro hover:opacity-80">
            <div className="w-8 h-8 bg-primary rounded-md flex items-center justify-center">
              <Icon name="Leaf" size={20} color="white" />
            </div>
            <span className="font-heading font-semibold text-xl text-foreground">
              Verduurzaamwijzer
            </span>
          </Link>

          {/* Navigation Links */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link
              to="/homepage"
              className="text-muted-foreground hover:text-foreground transition-micro"
            >
              Home
            </Link>
            <Link
              to="/provider-login"
              className="text-muted-foreground hover:text-foreground transition-micro"
            >
              Inloggen
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <Link
              to="/provider-login"
              className="text-sm font-medium text-primary hover:text-primary/80 transition-micro"
            >
              Inloggen
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default RegistrationHeader;